'use strict';

angular.module('enervexSalesappApp').factory('GlobalHubspotDeal', function ($resource) {
	// the dashboard HubSpot tab: every job's deal, read only
	return $resource('/api/hubspot-deals/:id', {
		id: '@_id'
	});
});
